import { LandingPage } from "../components/landing/landing-page";

export default function Home() {
  return <LandingPage locale="en" />;
}
